import { Injectable } from '@angular/core';
import { throwError, BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CustomLoaderService {
    loaderStatus$ = new BehaviorSubject<{ status: boolean, message: string, showProgress: boolean }>({ status: false, message: '', showProgress: false });
    cancelCallbackFn?: Function = null;

    constructor(
    ) {
    }

    show(message: string, showProgress?: boolean, cancelCallbackFn?: Function) {
        this.cancelCallbackFn = cancelCallbackFn || null;
        this.loaderStatus$.next({ status: true, message: message, showProgress: showProgress !== undefined && showProgress === true });
    }

    hide() {
        this.loaderStatus$.next({ status: false, message: null, showProgress: false });
    }
}